import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import '@etchteam/diamond-ui/control/Button/Button';
export default function ErrorPage({ link = '/', message, cta, }) {
    const { t } = useTranslation();
    return (_jsxs(_Fragment, { children: [_jsx("h2", { children: t('error.title') }), message && _jsx("p", { children: message }), _jsx("p", { className: "diamond-text-size-sm", children: t('error.message') }), _jsx("p", { className: "diamond-spacing-bottom-md diamond-text-weight-bold", children: t('error.label') }), _jsx("diamond-button", { width: "full-width", variant: "primary", children: _jsx(Link, { to: link, children: cta ?? t('error.cta') }) })] }));
}
